import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {PartnerDto, SchoolSubBillInfo, TransactionDto} from '../api/models';
import { PartnerCtlService, SchoolBillControllerService, TransactionCtlService } from '../api/services';
import { SessionService } from '../common/session.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import * as bootstrap from 'bootstrap';
import { ExcelService } from '../common/excel.service';
import { PdfService } from '../common/pdf.service';
import { saveAs } from  'file-saver';

@Component({
    selector: 'app-transaction',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxPaginationModule
    ],
    templateUrl: './transaction.component.html',
    styleUrl: './transaction.component.css'
})
export class TransactionComponent  implements OnInit{

  pageConfig= {
    itemsPerPage: 20,
    currentPage: 0,
    totalItems: 0
   };

  transactions?:any;
  filteredTransactions:Array<TransactionDto>=[];
  merchants?:Array<PartnerDto>;
  partnerType?:string
  searchForm:FormGroup;
  startDate='';
  endDate ='';
  message ='';
  messageColor='';
  idPartner?:number;
  mcc?:string;
  currentTrx:TransactionDto ={};
  currentParam={
    idPartner:'0',
    startDate:'',
    endDate:''
  }
  partnerLabel ='';
 
  partner?:PartnerDto;
  searchTrx:FormControl =new FormControl();

  constructor(private trxService:TransactionCtlService,
             private partnerService: PartnerCtlService,
             private billService:SchoolBillControllerService,
             private session: SessionService,
             private formBuilder:FormBuilder,
             private excelService:ExcelService,
             private pdfService:PdfService
  ){
    this.searchForm = this.formBuilder.group({
      startDate :['', [Validators.required]],
      endDate :['', [Validators.required]],
      partner :['', [Validators.required]],
    });
   
    this.searchTrx = new FormControl();
  }
  ngOnInit(): void {
    this.partner =this.session.getSessionInfo().partner;
    this.mcc =this.partner?.mcc;
    if(this.partner?.mcc=='5812'){
       this.partnerLabel= 'Veuillez selectionner un restaurant';
        }else if(this.partner?.mcc=='8299'){
        this.partnerLabel= 'Veuillez selectionner un établissement';
        }else if(this.partner?.mcc=='6513'){
        this.partnerLabel= 'Veuillez selectionner un promoteur';
        }else {
        this.partnerLabel= 'Veuillez selectionner un partenaire';
        }
    if(this.partner?.canBeParent){
      this.loadMerchants();
      this.getTransactions();
    }else {
      this.idPartner =this.session.getSessionInfo().partner?.id;
      this.getTransactions(this.idPartner);
    }

    
    
  }
  loadMerchants()
  {
    this.partnerService.getChildren(
      this.session.getSessionInfo().partner?.id!!,
      undefined,
      0,
      1000
    ).subscribe(
      {
        next:(resp)=>{
          this.merchants = resp.content;
        }
      }
    )
  }

  getTransactions(partner?:number,start?:string,end?:string,pageSize:number=10,pageNumber:number=0,toExport:boolean=false){

    this.trxService.getTransactions(
      pageNumber,
      pageSize,
      partner,
      start,
      end
    ).subscribe(
      {
        next:(resp)=>{
          if(toExport){
            let content =[['DATE','MONTANT','STATUS','NOM MARCHAND','MOYEN PAIEMENT','REFERENCE','NOM CLIENT','REFERENCE CLIENT']];

             if(this.partner?.mcc=='8299'){
              content =[['DATE','MONTANT','STATUS','NOM MARCHAND','MOYEN PAIEMENT','REFERENCE','NOM ELEVE','REFERENCE ELEVE','CLASSE']];
             }
            resp?.content?.forEach(el => {
              var dateModified;
              if(el.status =='PAID'||el.status =='VALIDATED'){
                dateModified =el.paymentDate;
              }else {
                dateModified =el.modifiedAt;
              }
              var status ='ECHEC';
              if(el.status =='PAID'||el.status =='VALIDATED'){
                status ='SUCCES';
              }else if(el.status =='PENDING'){
                status = 'EN ATTENTE';
              }

              let details = el.details;
              var line:any[] =[dateModified,el.amount,status,el.partner?.name,el.paymentNetwork,el.reference,details?.['customerName'],details?.['customerId']];
              if(this.partner?.mcc=='8299'){
                line.push(details?.['customerClass']);
              }
              if(this.partner?.mcc=='8299'){
                if(status=='SUCCES'){
                  content.push(line);
                }
            }else {
              content.push(line);
            }
            
          });
          this.excelService.exportAsExcelFile(content,'transactions','transactions');
          }else {
           this.transactions =resp;
           this.pageConfig.currentPage= resp.page?.number!!+1;
           this.pageConfig.itemsPerPage= resp.page?.size!!;
           this.pageConfig.totalItems =  resp.page?.totalElements!!;
           this.filteredTransactions = resp.content||[];
           this.searchTrx.setValue('');
          }
        }
      }
    )

  }
  onGetTransaction(){

    let form = this.searchForm.value;
    let startDate=form.startDate;
    let endDate =form.endDate;
    if(form.startDate.length>0){
       let start = startDate.substring(8,10)+'/'+startDate.substring(5,7)+'/'+startDate.substring(0,4);
       this.startDate = start;
    }
    if(form.endDate.length>0){
      let end = endDate.substring(8,10)+'/'+endDate.substring(5,7)+'/'+endDate.substring(0,4);
      this.endDate = end;
   }
   this.idPartner = form.partner;
    console.log(form);
    console.log(endDate);
    this.getTransactions(form.partner,this.startDate,this.endDate);

  }
  onNextPage(event:number){
    console.log("page"+event);
    this.getTransactions(this.idPartner, this.startDate,this.endDate, this.pageConfig.itemsPerPage,event-1);
  }
  onDetailsTrx(trx:TransactionDto){
    console.log(trx);
    this.currentTrx =trx;
    const elt =document.getElementById('detailsTrx');
               const modAdd = new bootstrap.Modal(elt!!);
               modAdd.show();
  }
  exportToExcel(){
    this.getTransactions(this.idPartner, this.startDate,this.endDate, -1,0,true);
  }
  exportToPdf(){
    
    this.trxService.getTransactions(
      0,
      -1,
      this.idPartner,
      this.startDate,
      this.endDate
    ).subscribe(
      {
        next:(resp)=>{
            let headers =[['DATE','MONTANT','STATUS','NOM MARCHAND','MOYEN PAIEMENT','REFERENCE',,'NOM CLIENT','REFERENCE CLIENT']];
            let content:any[] =[];
            if(this.partner?.mcc=='8299'){
              headers =[['DATE','MONTANT','STATUS','NOM MARCHAND','MOYEN PAIEMENT','REFERENCE','NOM ELEVE','REFERENCE ELEVE','CLASSE']];
             }
            
            resp?.content?.forEach(el => {
              let status ='ECHEC';
              let dateModified =el.modifiedAt;
              
              if(el.status =='PAID'||el.status =='VALIDATED'){
                status ='SUCCES';
                dateModified =el.paymentDate;
              }else if(el.status =='PENDING'){
                status = 'EN ATTENTE';
              }
              
              let details =el.details;
              console.log(details);
              var line:any[] =[dateModified,el.amount,status,el.partner?.name,el.paymentNetwork,el.reference,details?.['customerName'],details?.['customerId']];
              if(this.partner?.mcc=='8299'){
                line.push(details?.['customerClass']);
              }
              if(this.partner?.mcc=='8299'){
                if(status=='SUCCES'){
                  content.push(line);
                }
            }else {
              content.push(line);
            }
            });
            this.pdfService.generateFile(headers,content,'Rapport de transactions','transactions-'+ new Date().getTime());
 
        }
      }
    );
  }
  exportSchema(){
    let form = this.searchForm.value;
    console.log(form);
    this.endDate=form.endDate.substring(8,10)+'/'+form.endDate.substring(5,7)+'/'+form.endDate.substring(0,4);
    this.startDate=form.startDate.substring(8,10)+'/'+form.startDate.substring(5,7)+'/'+form.startDate.substring(0,4);
    if(this.startDate.length <10||this.endDate.length <10){
      this.message = 'Veuillez renseigner la periode';
              this.messageColor ='text-danger';
                      
              const elt =document.getElementById('modalResult');
              const modAdd = new bootstrap.Modal(elt!!);
              modAdd.show();

    }else {
      this.billService.getAccountSchema1(
        this.session.getSessionInfo().partner!!.id!!,
        this.startDate,
        this.endDate
      ).subscribe(
        {
          next:(resp)=>{

            let len = resp.bills!!.length+resp.subscriptions!!.length;
            if(len ==0){
              this.message = 'Il n\'y a pas d\'opération disponible sur cette période';
              this.messageColor ='text-danger';
                      
              const elt =document.getElementById('modalResult');
              const modAdd = new bootstrap.Modal(elt!!);
              modAdd.show();

            }else {
              let tab = '\t';
              let headers ="Date de l'écriture".
              concat(tab,"Journal",tab,"Compte",tab,'Libelle du compte',tab, 'numéro de pièce',tab,
    "Libelle de l'écriture",tab,"Montant de l'écriture",tab, "sens de l'écriture",tab, 
    'poste analytique plan1',tab,'libellé poste analytique plan1'+'\r\n');
              let line1='',line2='';
              
              
              let fileName ='rapport_encaissement_'+resp.school?.name+'_'+ new Date().getTime()+".txt";
              let bill ='';
              resp.bills?.forEach(el => {
                if(el.status =='PAID'){
                  let colA=''.concat(el.modifiedAt!!.substring(6,10),el.modifiedAt!!.substring(3,5),el.modifiedAt!!.substring(0,2)).concat(tab);
                  let colB ='ENCSMK'.concat(tab);
                  let colC=el.idStudent!!.padEnd(15).concat(tab);
                  let colD=''.concat(tab);
                  let colE=''.concat(tab);
                  let colF='Paiement_SchoolMatik'.concat(tab);
                  let colG=line1.concat(el.amount!!.toString()).concat(tab);
                  let colH='C'.concat(tab);
                  let colH2='D'.concat(tab);
                  let colC2='513100000000'.padEnd(15).concat(tab);
                  
                  line1 =colA.concat(colB,colC,colD,colE,colF, colG,colH,tab,tab,'\r\n');
                  line2 =colA.concat(colB,colC2,colD,colE,colF,colG,colH2,tab,tab,'\r\n');

                  console.log(line1);
                  console.log(line2);

                  bill =bill.concat(line1).concat(line2);
                  line1='';
                  line2='';
              
                }
              });
              let subscriptions = this.schemaSubscription(resp.subscriptions);
              let data =headers.concat(bill).concat(subscriptions);
              this.saveSchema(data,fileName);
            }
   
          }
        }
      );
    }

  }
  schemaSubscription(resp?:Array<SchoolSubBillInfo>){

    let tab = '\t';
              let data ='';
              let lineGeneralFee='',lineFurniture='',lineLastMonth='',lineApec='',
              lineCantine='',lineTransport='',lineTotal='';
              resp?.forEach(el => {
                if(el.status =='PAID'){
                  let colA=''.concat(el.modifiedAt!!.substring(6,10),el.modifiedAt!!.substring(3,5),el.modifiedAt!!.substring(0,2)).concat(tab);
                  let colB ='ENCSMK'.concat(tab);
                  let colC=el.idStudent!!.padEnd(15).concat(tab);
                  let colD=''.concat(tab);
                  let colE=''.concat(tab);
                  
                  
                  lineGeneralFee =colA.concat(colB,colC,colD,colE,'Frais generaux annuel'.concat(tab),''.concat(el.level!!.yearlyFee!!.toString()).concat(tab),'C'.concat(tab),tab,tab,'\r\n');
                  lineFurniture =colA.concat(colB,colC,colD,colE,'Mois Octobre'.concat(tab),''.concat(el.level!!.firstMonthAmount!!.toString()).concat(tab),'C'.concat(tab),tab,tab,'\r\n');
                  lineApec =colA.concat(colB,colC,colD,colE,'APEC'.concat(tab),''.concat(el.level!!.apecAmount!!.toString()).concat(tab),'C'.concat(tab),tab,tab,'\r\n');
                  
                 let items ='';
                 el.level?.otherItems?.forEach(it=>{
                  let line = colA.concat(colB,colC,colD,colE,it.libelle!!.concat(tab),''.concat(it.value!!.toString()).concat(tab),'C'.concat(tab),tab,tab,'\r\n');
                  items =items.concat(line);
                 })
                  if(el.transportSubscription){
                    let transport = el.transport!!.monthlyAmount!!+el.transport!!.subscription;
                  lineTransport =colA.concat(colB,colC,colD,colE,'Transport et inscription'.concat(tab),''.concat(transport.toString()).concat(tab),'C'.concat(tab),tab,tab,'\r\n');
                  }
                  
                  lineTotal =colA.concat(colB,'513100000000'.padEnd(15).concat(tab),colD,colE,'Total Reinscription'.concat(tab),''.concat(el.amount!!.toString()).concat(tab),'D'.concat(tab),tab,tab,'\r\n');
                  
                  
                  data =data.concat(lineGeneralFee).concat(lineFurniture).concat(lineLastMonth)
                  .concat(lineApec).concat(lineCantine).concat(lineTransport).concat(items).concat(lineTotal);
                  lineGeneralFee='';
                  lineFurniture='';
                  lineLastMonth='';
                  lineApec='';
                  lineCantine='';
                  lineTransport='';
                  lineTotal=''
              
                }
              });
              return data;
   }
  saveSchema(buffer:string, fileName:string){
    const data: Blob = new Blob([buffer], {
      type: 'text/octetstream',
    });
    saveAs(
      data,
      fileName 
    );
  }
  onSearchTrx(event:any){
    var table, tr, td, i, txtValue;
    let searchKey = this.searchTrx.value.toUpperCase();
    this.filteredTransactions =this.transactions?.content||[]
    
    if(searchKey.length >0){
      this.filteredTransactions = this.filteredTransactions.filter((trx)=>{
        return (
          (trx.requestId ? trx.requestId.toUpperCase().indexOf(searchKey) > -1 : false) ||
          (trx.reference ? trx.reference.toUpperCase().indexOf(searchKey) > -1 : false) ||
          (trx.partner?.name ? trx.partner.name.toUpperCase().indexOf(searchKey) > -1 : false)
        );
      });

    }
  }
  
}
